module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karen Miller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Karen Miller")]), _vm._v(" was born in Vancouver, Canada, and moved to Australia with her family when she was two. Apart from a three-year stint in the UK after graduating from university with a BA in communications, she's lived in and around Sydney ever since. Karen started writing stories while still in elementary school, where she fell in love with speculative fiction.  She's held a variety of interesting jobs but now writes full time.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4AfXqG/images/9780316209229.jpg?1732137007884",
      "alt": "This image is the cover for the book Godspeaker Trilogy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Godspeaker Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sold into slavery, Hekat dreams of power. Fate leads her to the warlord Raklion, and she begins turning dreams into reality. For the nameless god of Mijak is with her, and it promises her the world."), _c('br'), _c('br'), _vm._v("Far away, the King of Ethrea is dying. His daughter Princess Rhian is ready to rule, but if her enemies have their way the crown of Ethrea will never be worn by a woman."), _c('br'), _c('br'), _vm._v("Dexterity Jones is a toymaker. To protect Rhian and his country, he must place his trust in an exile from Mijak. Yet, as Ethrea comes ever closer to civil war, a greater danger awaits. "), _c('br'), _c('br'), _vm._v("Hekat still desires the world . . . and power is no longer a dream."), _c('br'), _c('br'), _vm._v("This omnibus edition of THe Godspeaker Trilogy includes "), _c('i', [_vm._v("Empress, The Riven Kingdom ")]), _vm._v("and "), _c('i', [_vm._v("The Hammer of God")]), _vm._v(".")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0